<template>
  <div class="contact py-5">
    <div class="container-fluid text-center py-lg-4 fw-bold px-3">
      <h5 class="lh-base fw-bold">{{contactInfo.introduction}}</h5>
      <div v-for="(item,index) in contactInfo.info" :key="index">
        <div class="lh-lg mt-4 mt-lg-5">
          <p v-html="item.content"></p>  
        </div>
          <div class="pic mt-4 mt-lg-5">
            <img :src="item.map" class="w-100 h-100 object-fit-cover">
          </div>
      </div>

    </div>
    
  </div>
</template>

<script>
import axios from '@/axios-auth'

export default {
  name: 'Contact',
  data () {
    return {
      contactInfo:''
    }
  },
  created(){
    axios.get('/about.json')
        .then( res => {
          return res.data
        })
        .then( response => {
          if(response.code == 0){
            this.contactInfo = response.data.contact
          }
        })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.contact p{ color: #666;}
.contact .pic{ margin-left: -1rem; margin-right: -1rem; }

@media (min-width: 576px) {

}

@media (min-width: 768px) {

}

@media (min-width: 992px) {

}

@media (min-width: 1200px) {
  .contact .pic{ max-width: 1079px; margin-left: auto; margin-right: auto;}
}

@media (min-width: 1400px) {
  
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue